//insytedata

import * as React from 'react'
import $ from 'jquery'
import { suspend } from 'suspend-react'
import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil';
import { Row, Col, Badge } from 'reactstrap';
import { GridColumn, GridNoRecords, Grid, getSelectedState } from '@progress/kendo-react-grid'
import { IntlProvider } from "@progress/kendo-react-intl";
import { ExcelExport } from "@progress/kendo-react-excel-export";
import { Menu} from '@progress/kendo-react-layout';
import { Popup } from "@progress/kendo-react-popup";
import { accentUtils, t, from, accentUserLang, formHelper, newGuid, showDialog } from '../../services/HelperService'
import { AccentSpinner, LoadingPanel } from './../AccentSpinner'
import { RTLGridColumnChooser } from './RTLGridColumnChooser'
import { RTLGridToolbarCtrl } from './RTLGridToolbar'
import { useGridData, gridSettingsManager, getGridFilter, getGridSort, getGridSearch, getGridDetails, getGridColumnsWidths, getGridHiddenColumns, getAdhocFilter, getAdvancedFilter, getQuickFilters, getGridExpandedItems, getGridSelectedItems, processDataForExport, getLastPage, getGridGroup } from './GridDataManager';
import GridErrorBoundary from './GridErrorBoundary';
import { ColumnMenu, ColumnMenuCheckboxFilter, ColumnMenuInsyteDate } from './RTLGridColumnMenu';
import { normalizeInsyteDateFilterValues } from './InsyteDateKendoCells';
import { RTLGridHeaderCellRender, RTLGridCellRender, RTLGridRowRender } from './RTLGridCellRender';
import { debounce } from 'perfect-debounce';
import { isMobileOnly, usePosition } from '../AccentDisplay';
import { classNames } from '@progress/kendo-react-common';
import { contextSources, setContext } from '../../services/EntityContextService';
import { OutsideAlerter } from '../OutsiderAlerter';
import { RTLGridContext, RTLGridContextProvider } from './RTLGridContext';
import { showResetGridLayoutDlg } from '../../dialogs/ResetGridLayoutDlg';
import { getAccess } from '../../services/UserService';



const filterOperators = {
    text: [
        {
            text: "grid.filterStartsWithOperator",
            operator: "startswith",
        },
        {
            text: "grid.filterEndsWithOperator",
            operator: "endswith",
        },
        {
            text: "grid.filterContainsOperator",
            operator: "contains",
        },
    ],
    numeric: [
        {
            text: "grid.filterEqOperator",
            operator: "eq",
        },
        {
            text: "grid.filterGtOperator",
            operator: "gt",
        },
        {
            text: "grid.filterGteOperator",
            operator: "gte",
        },
        {
            text: "grid.filterLtOperator",
            operator: "lt",
        },
        {
            text: "grid.filterLteOperator",
            operator: "lte",
        },
    ],
    date: [
        {
            text: "grid.filterGtOperator",
            operator: "gt",
        },
        {
            text: "grid.filterGteOperator",
            operator: "gte",
        },
        {
            text: "grid.filterLtOperator",
            operator: "lt",
        },
        {
            text: "grid.filterLteOperator",
            operator: "lte",
        },
    ],
    boolean: [
        {
            text: "grid.filterEqOperator",
            operator: "eq",
        },
    ],
    // Calendar-only (InsyteDate) columns: a whole-day equality is meaningful here, unlike the
    // date-time columns above, and the value sent is the "yyyy-MM-dd" literal.
    insytedate: [
        {
            text: "grid.filterEqOperator",
            operator: "eq",
        },
        {
            text: "grid.filterAfterOperator",
            operator: "gt",
        },
        {
            text: "grid.filterAfterOrEqualOperator",
            operator: "gte",
        },
        {
            text: "grid.filterBeforeOperator",
            operator: "lt",
        },
        {
            text: "grid.filterBeforeOrEqualOperator",
            operator: "lte",
        },
    ],
};




function getDefaultColumnWidth(screen, colWidth, numberOfColumns) {
    const minWidth = 110;

    const expectedGridWidth = minWidth * numberOfColumns;

    if (!accentUtils.isNull(colWidth)) {
        return colWidth;
    }


    if (screen < expectedGridWidth) {
        gridColumnMode = 2;
        return minWidth;
    }


    gridColumnMode = 1;
    return undefined;

}


const setGridFilterDebounced = debounce(action => action(), 900, { trailing: false });


const DefaultNotesCtrl = props => {


    let notes = "";

    if (props.dataItem) {
        if (props.dataItem.detailsField) {
            notes = props.dataItem[props.dataItem.detailsField];
        }
    }
    

    return <section>
        <textarea key={props.dataItem.ID} disabled defaultValue={notes}></textarea>
    </section>;    
};


const GridCtrl = React.memo(props => {


    const toolbar = React.useRef();
    const exporter = React.useRef();
    const gridCtrl = React.useRef();

    const [search, setSearch] = useRecoilState(getGridSearch(props.gridID));
    const [lastPage, setLastPage] = useRecoilState(getLastPage(props.gridID));


    // The grid's column fields let the settings manager drop saved sort / width / hidden-column entries that
    // belong to a different grid (see GridSettingsManager.sanitise). This is the first getSettings call for the
    // grid, so the Recoil atoms read the cleaned copy.
    const validFields = React.useMemo(
        () => (props.columns ?? []).map((c, index) => formHelper.getGridColumn(c, index)?.field).filter(f => !accentUtils.isEmpty(f)),
        [props.columns]
    );

    const settings = suspend(async () => await gridSettingsManager.getSettings(props.gridID, validFields), [props.gridID, props.gridLoadID]);

    const [requireFireRefresh, setRequireFireRefresh] = React.useState(false);
    const [contextMenuState, setContextMenuState] = React.useState({ open: false });


    const [gridAdhocFilter, resetAdhocFilter] = useRecoilState(getAdhocFilter(props.gridID));
    const [gridAdvancedFilter, resetAdvancedFilter] = useRecoilState(getAdvancedFilter(props.gridID));
    const resetShowDetails = useSetRecoilState(getGridDetails(props.gridID));
    const [gridQuickFilters, resetQuickFilter] = useRecoilState(getQuickFilters(props.gridID));

    const resetColumnWidths = useSetRecoilState(getGridColumnsWidths(props.gridID));
    const resetHiddenColumns = useSetRecoilState(getGridHiddenColumns(props.gridID));
    const resetSort = useSetRecoilState(getGridSort(props.gridID));
    const resetFilter = useSetRecoilState(getGridFilter(props.gridID));

    const resetSearch = useSetRecoilState(getGridSearch(props.gridID));




    const gridData = useGridData(props.gridID, props.query, props.customQueryHeader, e => setRequireFireRefresh(true), lastPage);
    // The atom (not the mount-time `settings` snapshot) is the single source of truth for widths so that a
    // resize of one column does not drop earlier resizes, and so Reset Layout renders through React.
    const [gridColumnWidths, setGridColumnWidths] = useRecoilState(getGridColumnsWidths(props.gridID));
    const [gridHiddenColumns, setGridHiddenColumns] = useRecoilState(getGridHiddenColumns(props.gridID));
    const [gridFilter, setGridFilter] = useRecoilState(getGridFilter(props.gridID));
    const [gridSort, setGridSort] = useRecoilState(getGridSort(props.gridID));
    const [gridGroup, setGridGroup] = useRecoilState(getGridGroup(props.gridID));
    const showDetails = useRecoilValue(getGridDetails(props.gridID));
    const [expanded, setExpanded] = useRecoilState(getGridExpandedItems(props.gridID));
    const [selected, setSelected] = useRecoilState(getGridSelectedItems(props.gridID));

    const [requireScrollToSelected, setRequireScrollToSelected] = React.useState(Object.keys(selected).length > 0);


    // InsyteDate ("yyyy-MM-dd") columns: filter values must stay calendar-date strings (see InsyteDateKendoCells).
    const insyteDateFields = React.useMemo(
        () => (props.columns ?? []).filter(c => c?.fieldType === "insytedate").map(c => c.fieldName),
        [props.columns]
    );

    const [localFilterState, setLocalFilterState] = React.useState(accentUtils.isNull(gridFilter) ? null : normalizeInsyteDateFilterValues(JSON.parse(JSON.stringify(gridFilter)), insyteDateFields));

    const onSelectedChanged = props.onSelectedChanged;

    const position = usePosition(props.gridID);

    const rtlGridContext = React.useContext(RTLGridContext);


    const onContextMenuOpen = React.useCallback((e, dataItem) => {
        e.preventDefault();

        const offset = { left: e.clientX, top: e.clientY + window.document.documentElement.scrollTop };

        setContextMenuState({ open: true, offset: offset });


    }, [setContextMenuState]);

    const onContextMenuSelect = React.useCallback((e) => {
        e.item.actionClick(e);

        setContextMenuState({ open: false });

    }, [setContextMenuState]);


    const notifySelectionChanged = React.useCallback(e => {

        if (onSelectedChanged) {
            onSelectedChanged({
                selected: gridData.data.filter(i => selected[i.ID] === true)
            });
        }        
    }, [onSelectedChanged, gridData.data, selected])

    const onHeaderSelectionChange = React.useCallback((e) => {

        const checkboxElement = e.syntheticEvent.target;
        const checked = checkboxElement.checked;

        const moreThanOneSelected = from(Object.keys(selected)).where(k => selected[k] === true).take(2).toArray().length === 2;

        const shouldSelectAll = !checked && !moreThanOneSelected;



        const newSelectedState = {};
        e.dataItems.forEach((item) => {
            newSelectedState[item.ID] = shouldSelectAll || checked;
        });
        setSelected(newSelectedState);


    }, [selected, setSelected]);

    const onSelectionChange = React.useCallback((e) => {

        const isCheckBox = e.syntheticEvent?.currentTarget?.className === "k-checkbox k-checkbox-md k-rounded-md";

        const ev = {
            ...e,
            shiftKey: e.syntheticEvent?.shiftWas,
            ctrlKey: e.syntheticEvent?.ctrlWas,
            dataItem: !isCheckBox && (e.syntheticEvent?.shiftWas || !e.syntheticEvent?.ctrlWas) ? null : e.dataItem
        };

        const newSelectedState = getSelectedState({
            event: ev,
            selectedState: selected,
            dataItemKey: "ID",
        });

        setSelected(newSelectedState);



    }, [selected, setSelected]);

    const onExpandChange = e => {

        setExpanded(x => {
            const newVal = { ...x, [e.dataItem.ID]: e.value };
            return newVal;
        });

    };

    const onGetDOM = () => { return gridCtrl.current?.element; }


    const onFilterChange = React.useCallback(e => {
        setLocalFilterState(normalizeInsyteDateFilterValues(e.filter, insyteDateFields));
    }, [setGridFilter, setLocalFilterState, insyteDateFields]);

    const onSortChange = React.useCallback(e => {
        setGridSort(e.sort);
    }, [setGridSort]);
    
    const onGroupChange = React.useCallback(e => {
        setGridGroup(e.group);
    }, [setGridGroup]);




    const onExcelExport = async e => {

        if (!accentUtils.isNull(exporter.current)) {


            const data = await gridData.fetchExport();

            const result = processDataForExport(data, gridCtrl.current.columns, props.detailsField, props.processExport);

            exporter.current.save(result.data, result.cols);

        }


    };

    const onColumnChooser = React.useCallback((e) => {

        if (props.columns) {

            const cols = props.columns.map((c, index) => {

                const col = formHelper.getGridColumn(c, index)

                var pc = accentUtils.isNull(props.processColumn) ? col : props.processColumn(col);
                return { ...c, title: pc.title };
            });


            showDialog(<RTLGridColumnChooser
                columns={cols}
                hidden={gridHiddenColumns ?? []}
                queryEntity={[props.strings]}
            />).then(e => {
                if (!e.canceled) {
                    setGridHiddenColumns(e.hidden ?? []);

                }
            });

        }
    }, [setGridHiddenColumns, gridHiddenColumns, props])



    const onColumnResize = React.useCallback((e) => {

        // Kendo raises onColumnResize continuously during a drag (end === false) and once on release / autofit
        // (end === true). Only a finished resize that actually changed the width is persisted.
        if (e.end === false) return;

        const colToResize = e.columns?.[e.index];
        if (accentUtils.isNull(colToResize) || accentUtils.isEmpty(colToResize.field)) return;

        const newWidth = Math.round(e.newWidth);
        if (!(newWidth > 0)) return;

        const columns = { ...gridColumnWidths };
        if (columns[colToResize.field] === newWidth) return;

        columns[colToResize.field] = newWidth;

        setGridColumnWidths(columns);


    }, [setGridColumnWidths, gridColumnWidths]);

    const getSelected = React.useCallback(() => {
        return gridData.data.filter(i => selected[i.ID] === true);
    }, [gridData, selected]);


    const updateDataItem = (changedItem) => {
        gridData.updateDataItem(changedItem);
    }

    // Whether the grid renders row details is only known once the columns are mapped further down; the ref lets
    // the reset callback read the latest value without re-creating on every render.
    const hasDetailsRef = React.useRef(false);

    const resetGridSettings = React.useCallback(async () => {

        const result = await showResetGridLayoutDlg({
            quickFilters: gridQuickFilters,
            filterSchemaName: props.filterSchemaName,
            advancedFilterMode: getAccess().modules().RTL_AdvancedFiltering() && props.allowFilter === true ? "saved" : "none",
            selectedAdvancedFilterName: gridAdvancedFilter?.Name,
            // Selecting a saved filter copies its conditions into the ad-hoc filter and edits only touch the
            // ad-hoc copy, so this is true whenever any Advanced Filter conditions are in effect.
            hasUnsavedAdvancedFilter: !accentUtils.isNull(gridAdhocFilter),
            hasSearch: !accentUtils.isNull(props.onSearch) || props.allowSearch === true,
            hasDetails: hasDetailsRef.current
        });

        if (result?.canceled) return;

        await gridSettingsManager.resetGridSettings(props.gridID);

        resetAdhocFilter(null);
        resetAdvancedFilter(null);
        resetShowDetails(false);
        // By default the quick filter buttons are kept and only deselected (BLINDS-20700); the dialog lets the
        // user opt in to removing them, after which they must be re-added from the "..." selector.
        resetQuickFilter(result.removeQuickFilters
            ? []
            : q => accentUtils.isNull(q) ? [] : q.map(x => ({ ...x, Selected: false })));
        resetColumnWidths({});
        resetFilter(null);
        resetHiddenColumns([]);
        resetSort(null);
        resetSearch(null);
        setLocalFilterState(null);
        props.refresh();

    }, [props, gridQuickFilters, gridAdvancedFilter, gridAdhocFilter, resetAdhocFilter, resetAdvancedFilter, resetShowDetails, resetQuickFilter, resetColumnWidths, resetFilter, resetHiddenColumns, resetSort, resetSearch, setLocalFilterState]);

    const onRefresh = React.useCallback(() => {
        gridData.refresh();
    }, [gridData]);

    const onSearch = e => {
        setSearch(e);
    };


    const onRowClick = e => {

        if (props.onRowClick) {
            props.onRowClick({ row: e.dataItem });
        }

    };


    const onScroll = (event) => {

        const e = event.nativeEvent;


        const atBottom = e.target.scrollTop + 10 >= e.target.scrollHeight - e.target.clientHeight;

        const a = e.target.scrollTop;
        const b = e.target.scrollHeight - e.target.clientHeight;

        const scrollPercentage = a / b;


        if (scrollPercentage > 0.40 || atBottom) {

            const nextPageNumber = Math.ceil(gridData.data.length / 40) + 1;
            gridData.fetchPage(nextPageNumber);

        }
    };


    const onCellLinkClick = (dataItem) => {
        if (!accentUtils.isNull(dataItem)) {
            //gridStateManager.setLastSelectedRow(props.gridSettings, dataItem.ID, this.state.data.length, dataItem.expanded);

        }
    };

    const prepData = (r) => {

        const expandOverridden = !accentUtils.isNull(expanded[r.ID]);
        const isSelected = selected[r.ID];
        const isExpanded = expandOverridden ? expanded[r.ID] : showDetails;
        const detailsField = props.detailsField;

        if (isSelected) {
            setContext(accentUtils.isNull(props.contextSource) ? contextSources.grid : props.contextSource, props.contextKey, r);
        }

        const isChanged = r.selected !== isSelected || r.expanded !== isExpanded || r.detailsField !== detailsField;

        if (isChanged) {

            r.expanded = isExpanded;
            r.selected = isSelected;
            r.detailsField = detailsField;

        }

        return r;
    }

    React.useImperativeHandle(
        props.methods,
        () => ({
            getSearchText: () => toolbar.current.getText(),
            getSelected: () => gridData.data.filter(i => selected[i.ID] === true),
            refresh: () => onRefresh(),            
            getData: () => gridData.data,
            select: ids => {

                const newSelection = {};

                ids.map(id => newSelection[id] = true);

                setSelected(newSelection);
            }
        }),
        [gridData, selected, onRefresh, setSelected, toolbar]
    );

    React.useEffect(() => {

        setGridFilterDebounced(() => setGridFilter(localFilterState));

    }, [localFilterState])

    React.useEffect(() => {

        if (requireFireRefresh) {
            if (props.onRefresh)
                props.onRefresh();

            setRequireFireRefresh(false);
        }

    }, [requireFireRefresh, setRequireFireRefresh]);

    React.useEffect(() => {

        if (props.clearSelection) {
            setSelected({});
        }
        if (props.clearFilters) {
            resetFilter(null);
            resetAdhocFilter(null);
            resetAdvancedFilter(null);
            resetQuickFilter(null);
            setLocalFilterState(null);
            if (!accentUtils.isEmpty(props.defaultSearchText)) {
                toolbar.current.setText(props.defaultSearchText);
                setSearch(props.defaultSearchText);

            } else {
                toolbar.current.clearText();
                resetSearch(null);

            }

        }






    }, [])


    React.useEffect(() => {
        setExpanded({});
    }, [showDetails]);

    React.useEffect(() => {


        if ((gridData?.data?.length ?? 0) !== 0) {

            const ids = Object.keys(selected);

            if (!from(ids).any(id => selected[id] === true )) {
                setSelected({ [gridData.data[0].ID]: true });
            }

        }


    }, [selected, gridData, setSelected]);


    React.useEffect(() => {

        setLastPage(last => gridData.lastPage === 1 ? 1 : last < gridData.lastPage ? gridData.lastPage : last);

    }, [gridData, setLastPage]);

    React.useEffect(() => {

        if (requireScrollToSelected && gridData.data.length > 0) {

            try {

                const grid = $(`#${props.gridID} > div.k-grid`);

                if (grid.length !== 0) {
                    const os = grid.offset().top;

                    const gridContainer = $(`#${props.gridID} > div.k-grid .k-grid-content`);

                    if (gridContainer.length !== 0) {

                        const firstSelectedRow = grid.find('.k-selected');

                        if (firstSelectedRow.length !== 0) {

                            const rowOffset = firstSelectedRow.offset().top;

                            setTimeout(() => {
                                gridContainer.animate({
                                    scrollTop: rowOffset - os - 50
                                }, 1500)
                            }, 10);

                            
                        }
                        
                    }
                }

                setRequireScrollToSelected(false);

            } catch (e) {
            }
            
            


        }

    }, [selected, requireScrollToSelected, setRequireScrollToSelected, gridData]);


    React.useEffect(() => {

        notifySelectionChanged();

    }, [notifySelectionChanged]);

    var queryEntity = props.strings;


    const gridSortable = accentUtils.isNull(props.sortable) ? true : props.sortable;

    const colInfos = [];

    const filterAsString = JSON.stringify(localFilterState);

    let detailsColumn = null;

    const cols = props.columns.map((c, index) => {

        const gCol = formHelper.getGridColumn(c, index);


        if (gCol.field === props.detailsField) {
            detailsColumn = gCol;
            return null;
        }


        const colHasFilter = filterAsString.search(`"field":"${gCol.field}"`);

        const headClass = classNames({
            "acc-numeric": gCol.filterType === "numeric",
            "acc-has-filter": colHasFilter !== -1
        });


        let colInfo = {
            field: gCol.field,
            title: !accentUtils.isNull(gCol.title) ? gCol.title : t(formHelper.getFieldLabel(t, [queryEntity], gCol.field, true)),
            editable: false,
            filterType: gCol.filterType,
            fieldType: gCol.fieldType,
            columnMenu: undefined,
            columnMenuQuery: undefined,
            headerCell: undefined,
            hide: gridHiddenColumns?.includes(gCol.field) ?? false,
            width: gCol.defaultWidth,
            headerClassName: headClass,
            cellTemplate: undefined,
            cellHeader: undefined,
            locked: gCol.locked,
            isDragCell: false,
            isDropDown: false,
            sortable: gridSortable,
            requireTranslate: gCol.requireTranslate,
            data: gridData,
            filterable: props.hideColumnFilters ? false : (gCol.allowFilter??true),
            isLink: !accentUtils.isNull(gCol.linkField),
            linkField: gCol.linkField,
            linkEntity: gCol.linkEntity,
            className: gCol.class,
            format: gCol.format
        };

        if (!accentUtils.isNull(gridColumnWidths?.[gCol.field])) {
            colInfo.width = gridColumnWidths[gCol.field];
        }

        if (props.processColumn) {
            colInfo = props.processColumn(colInfo);
        }

        if (colInfo.hide) {
            return null;
        }


        if (!accentUtils.isEmpty(colInfo.filterType) && colInfo.filterable) {
            if (accentUtils.isNull(colInfo.columnMenu)) {

                if (colInfo.filterQuery) {
                    colInfo.columnMenu = p => <ColumnMenuCheckboxFilter {...p} field={colInfo.field} query={colInfo.filterQuery} requireTranslate={colInfo.requireTranslate} />;
                } else if (colInfo.filterType === "insytedate") {
                    colInfo.columnMenu = ColumnMenuInsyteDate;
                } else {
                    colInfo.columnMenu = ColumnMenu;
                }
            }
        }

        colInfos.push(colInfo);

        const screen = position?.toScreenWidth ?? window.innerWidth;

        const adjustmentColWidth = getDefaultColumnWidth(
            screen,
            colInfo.width,
            props.columns.length
        );

        //console.log(`${colInfo.field}: '${colInfo.width}' '${adjustmentColWidth}'`);

        //if (isMobileOnly && props.columns.length > 3) {
        //    if (colInfo.width ?? 0 < 90) {
        //           colInfo.width = 90;
        //    }
        //}

        return (<GridColumn
            key={`col_${colInfo.field}`}
            id={colInfo.field}
            locked={colInfo.locked}
            sortable={colInfo.sortable}
            className={ colInfo.className }
            field={colInfo.field}
            title={colInfo.title}
            width={accentUtils.isNull(adjustmentColWidth) ? undefined : `${adjustmentColWidth}px`}
            columnMenu={colInfo.columnMenu}
            filter={colInfo.filterType}
            headerClassName={colInfo.headerClassName}
            headerCell={colInfo.cellHeader}
            filterable={colInfo.filterable}
            editable={false}
            format={colInfo.format}
        />);
    });

    if (props.showCheckbox) {
        cols.unshift(<GridColumn
            key="selectCol"
            field="selected"
            width="50px"
            headerSelectionValue={
                from(gridData.data).any(x => selected[x.ID] === true)
            } />);
    }


    const exportToExcelAction = [{
        title: "Export to Excel",
        onClick: onExcelExport
    }, {
        title: "Columns",
        onClick: onColumnChooser
    }, {
        title: "Reset Layout",
        onClick: resetGridSettings
    }];


    const actions = props.hideActions ? [] : (accentUtils.isNull(props.getActions) ? exportToExcelAction : props.getActions().concat(exportToExcelAction)).map(a => {
        return {
            ...a,
            title: t(a.title),
            onClick: e => {
                e.getSelectedGridRows = getSelected;
                a.onClick(e);
            }
        };

    });


    const contextItems = actions.map(a => { return { text: a.title, actionClick: a.onClick, cssClass: classNames("acc-grid-context-item", { "divider": a.divider }) } });

    if (!accentUtils.isNull(props.actionCell)) {

        const actionCellInfo = props.actionCell;

        const colIndex = actionCellInfo.columnIndex;

        const actionCol = <GridColumn
            key="action"
            field="action"
            title={props.actionCell?.title ?? " "}
            width={actionCellInfo && actionCellInfo.width ? actionCellInfo.width : 50}
            filter="text"
            encoded={false}
            headerClassName={`act-header-action hidden`}
            sortable={false}
            filterable={false}
            editable={false}
        />;

        if (accentUtils.isNull(colIndex)) {
            cols.push(actionCol);
        } else {
            const validIndex = Number.isInteger(colIndex) ? colIndex : null;

            if (validIndex !== null && validIndex >= 0 && validIndex <= cols.length) {
                // Insert actionCol at the specified colIndex
                cols.splice(validIndex, 0, actionCol);
            } else {
                // If colIndex is out of bounds or invalid, append actionCol to the end
                cols.push(actionCol);
            }
        }
        
    }


    const notRecClearFilter = <GridNoRecords><div onContextMenu={ onContextMenuOpen}>
        {gridData.loading ? "Loading..." : "There is no data available."}
        </div>
    </GridNoRecords>;





    const adjustment = props.screenBottomMargin ?? 40;

    const height = props.height === "screen" && !accentUtils.isNull(position) ? `${position.toScreenHeight - adjustment}px` : accentUtils.isNull(props.height) ? "100%" : `${props.height}px`


    const detailsComponent = (rtlGridContext?.details?.component) ?? (!accentUtils.isEmpty(detailsColumn) ? DefaultNotesCtrl  : null);
    
    const hasDetails = !accentUtils.isNull(detailsComponent)
    hasDetailsRef.current = hasDetails;


    return <div className={`rtl-grid ${props.className}`}  >
        <IntlProvider locale={accentUserLang}>
            <div>
                <ExcelExport
                    ref={exp => exporter.current = exp}
                />
                <RTLGridToolbarCtrl
                    methods={ toolbar}
                    gridID={props.gridID}
                    readOnly={gridData.loading}
                    visible={props.showToolbar}
                    showSearch={!accentUtils.isNull(props.onSearch) || props.allowSearch}
                    onSearch={onSearch}
                    onRefresh={onRefresh}
                    defaultSearchText={search}
                    actions={actions}
                    hasDetails={hasDetails}
                    allowFilter={props.allowFilter}
                    filterSchemaName={props.filterSchemaName}
                    defaultShowDetails={settings?.ShowDetails ?? false}
                />
                <div id={props.gridID}>
                    {/* gridLoadID changes on Reset Layout. Kendo writes drag-resized widths straight to the
                        <col> elements and fixes the table width from them, so the grid must be remounted to
                        discard them and to lay out re-shown columns correctly. */}
                    <Grid
                        key={`${gridColumnMode}_${props.gridLoadID}`}
                        style={{ height: height, width: "100%" }}
                        onScroll={onScroll}
                        fixedScroll={true}
                        navigatable={false}
                        rowRender={(r, p) => RTLGridRowRender(r, p, onContextMenuOpen)}
                        headerCellRender={(c, p) => <RTLGridHeaderCellRender props={p} cell={c} colInfos={colInfos} />}
                        cellRender={(c, p) => RTLGridCellRender(c, p, colInfos, updateDataItem, onRowClick, props.actionCell?.template)}
                        ref={g => gridCtrl.current = g}
                        data={gridData.data.map(prepData)}
                        selectedField="selected"
                        onSelectionChange={onSelectionChange}
                        selectable={{
                            enabled: false,
                            drag: props.showCheckbox,
                            cell: false,
                            mode: props.showCheckbox ? "multiple" : "single",
                        }}
                        expandField="expanded"
                        onColumnResize={onColumnResize}
                        onHeaderSelectionChange={onHeaderSelectionChange}
                        detail={detailsComponent}
                        onFilterChange={onFilterChange}
                        sort={gridSort}
                        onSortChange={onSortChange}
                        filter={localFilterState}
                        filterOperators={filterOperators}
                        pageable={false}
                        resizable={true}
                        reorderable={props.reorderable}
                        sortable={!gridData.loading && gridSortable}
                        dataItemKey={"ID"}
                        onExpandChange={!hasDetails ? undefined : onExpandChange}
                        groupable={props.groupable}
                        group={gridGroup}
                        onGroupChange={onGroupChange}
                        >
                        {notRecClearFilter}
                        {cols}
                    </Grid>
                </div>
                <Popup
                    offset={contextMenuState.offset}
                    show={contextMenuState.open}
                    popupClass={"popup-content"}
                >
                    <OutsideAlerter onAlert={e => setContextMenuState({open: false}) }>
                    <Menu
                        vertical={true}
                        style={{ display: "inline-block" }}
                        onSelect={onContextMenuSelect}
                        items={ contextItems }
                    />
                     </OutsideAlerter>
                </Popup>
                <Row className="acc-grid-footer">
                    <Col lg={12} md={12}>{`Showing ${gridData.data.length} of ${accentUtils.isNull(gridData.total) ? 0 : gridData.total}`}</Col>
                </Row>
            </div>
        </IntlProvider >
        {gridData.loading && <LoadingPanel onGetDOM={onGetDOM} onContextMenu={onContextMenuOpen}   />}
    </div>

});


var gridColumnMode = 1;

export function formartGridID(id){
    return `g_${id}`
}


export const RTLGridCtrl = React.memo(props => {

    const [loadID, setLoadID] = React.useState(`g_${newGuid()}`);

    


    const onRefresh = React.useCallback(() => {

        setLoadID(`g_${newGuid()}`);

    },[setLoadID])

    React.useEffect(() => {

        if (accentUtils.isEmpty(props.gridID)) {
            alert("All grids must have a unique ID");
        }

    }, []);


    return <GridErrorBoundary>
        <React.Suspense fallback={<div stlye={{ minHeight: "300px" }}><AccentSpinner /></div>}>
            <RTLGridContextProvider detailsContext={props.detailsContext}>
                <GridCtrl methods={props.methods} gridLoadID={loadID} {...props} gridID={formartGridID(props.gridID)} refresh={onRefresh} />
            </RTLGridContextProvider>            
        </React.Suspense>
    </GridErrorBoundary>;
});
